declare namespace $ {

	type $shm_button_copy__title_shm_hitalama_profile_switch_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__hint_shm_hitalama_profile_switch_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_hitalama_profile_switch_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_switch['client_id'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $shm_hitalama_profile_badge__name_shm_hitalama_profile_switch_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_switch['login'] >
		,
		ReturnType< $shm_hitalama_profile_badge['name'] >
	>
	type $shm_hitalama_profile_badge__avatar_uri_shm_hitalama_profile_switch_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_switch['avatar_uri'] >
		,
		ReturnType< $shm_hitalama_profile_badge['avatar_uri'] >
	>
	type $mol_link__title_shm_hitalama_profile_switch_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_switch['login'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_hitalama_profile_switch_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__hint_shm_hitalama_profile_switch_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__arg_shm_hitalama_profile_switch_9 = $mol_type_enforce<
		({ 
			'section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_hitalama_profile_switch_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_shm_hitalama_profile_switch_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_profile_switch_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_shm_hitalama_profile_switch_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	export class $shm_hitalama_profile_switch extends $mol_view {
		client_id( ): string
		Client_copy( ): $shm_button_copy
		login( ): string
		avatar_uri( ): string
		Login_badge( ): $shm_hitalama_profile_badge
		Login( ): $mol_link
		Enter_link( ): $mol_link
		Register_link( ): $mol_link
		profile( ): $shm_hitalama_profile | null
		align( ): string
		sub( ): readonly(any)[]
		buttons( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map